import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ChangePassword, defaultChangePasswordValues } from 'src/app/components/users/change-password';
import { AuthService } from 'src/app/services/auth.service';
import { ChangePasswordService } from 'src/app/services/change-password.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { ApplicationRoles } from '../users/user-roles';
import { CheckPageAccess } from '../authorize/check-page-access';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-changepassword',
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  
  changePasswordObj: ChangePassword = defaultChangePasswordValues();
  confirmPassword: string = "";
  message: string = "";
  userRole: ApplicationRoles = ApplicationRoles.BB_Coach;
  cancelLink: string = '';
  navPageAccess: CheckPageAccess = CheckPageAccess.DASHBOARDADMIN;
  llttfPage = false;
  revealNewPassword: boolean = false;
  revealConfirmPassword: boolean = false;
  translations: any;
  constructor(
    private _changepassowrdservice: ChangePasswordService,
    private _toastService: ToastService,
    private router: Router,
    private _authService: AuthService,
    private translationService: TranslationService
  ) { }

  changePassword(changepasswordForm: NgForm) {
    if (changepasswordForm.invalid) {
      this.message = this.translations?.['passwordRequiredText'] || "Field is Required";
      Object.values(changepasswordForm.controls).forEach(control => control.markAllAsTouched());
      return;
    }
    else if (this.changePasswordObj.newPassword != this.confirmPassword) {
      Object.values(changepasswordForm.controls).forEach(control => control.markAsDirty());
      this.message = this.translations?.['passwordsDoNotMatchDetailText'] || "Passwords do not match. Please type the correct password";
      return;
    }
    else {
      this._changepassowrdservice.changepassword(this.changePasswordObj).subscribe({
        next: (res) => {
          if (res.status) {
            this._toastService.showMessage(this.translations?.['passwordChangedSuccessText'] || "Password Changed Successfully. Please login again.");
            this._authService.logout();
            this.router.navigate(['/bb-login']);
          } else {
            this._toastService.showMessage(this.translations?.['passwordChangeIncorrectText'] || "Current password is incorrect, or the new password could not be saved.");
          }
        },
        error: (err) => {
          this._toastService.showMessage(this.translations?.['passwordChangeErrorText'] || "Error in changing password. Please contact CMHA Admin.");
        }
      })
    }
  }

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });

    this.userRole = this._authService.getRole();
    const login = this._authService.getUserLoginData();
    this.changePasswordObj.userDbId = login.userDbId;
    this.cancelLink = login.isParticipant ? '/dashboard-participant' : '/dashboard-bb';
    this.navPageAccess = login.isParticipant
      ? CheckPageAccess.DASHBOARDPARTICIPANT
      : CheckPageAccess.DASHBOARDADMIN;
    this.llttfPage =
      login.isParticipant &&
      this._authService.getAccessControl().participantLastActiveRole === ApplicationRoles.LLTTF_CoachedParticipant;
  }
  

}
